import { DataSourcesTypes } from '@frontend/api-data-sources';
import { PersonTypes } from '@frontend/api-person';
import { contextFactory } from '@frontend/design-system';
import { SourceTenantListItem } from '../../EventsPanel/ScheduleActions/ScheduleRequests/ScheduleRequestModal/types';
import {
  AddToListHandlerParamsType,
  FormFields,
  PatientSelectorScreenEnum,
  PersonSelectorFormValues,
  TransformedLegacyPerson,
} from './types';

export type ManagePersonListContextType = {
  shouldRenderNotes?: boolean;
  locationId: string;
  selectedPerson: PersonTypes.Person | null;
  personSelectorScreen?: PatientSelectorScreenEnum;
  defaultSearchValue?: string;
  setDefaultSearchValue?: (value: string) => void;
  isLoading?: boolean;
  closePopoverDialog: () => void;
  setPersonSelectorScreen: (screen: PatientSelectorScreenEnum) => void;
  setSelectedPerson: (person: TransformedLegacyPerson | null) => void;
  onAddToListHandler?: (personDetails: AddToListHandlerParamsType) => void;
  handleAddCustomerContact?: (personDetails: PersonSelectorFormValues) => Promise<void>;
  formFields: FormFields;
  clientLocationIds?: DataSourcesTypes.AccessDataResponse['ClientLocations'];
  addContactScreenTitle?: string;
  showDataSources?: boolean;
  addNewButtonTrackingId?: string;
  addToListButtonTrackingId?: string;
  cancelButtonTrackingId?: string;
  patientWritebackSourceTenants?: SourceTenantListItem[];
  shouldAddAndLink?: boolean;
  disableCustomContacts?: boolean;
};

export const [ManagePersonListContext, useManagePersonListContext] = contextFactory<ManagePersonListContextType>();
